import { render, staticRenderFns } from "./EditCliente.vue?vue&type=template&id=749beb50&scoped=true"
import script from "./EditCliente.vue?vue&type=script&lang=js"
export * from "./EditCliente.vue?vue&type=script&lang=js"
import style0 from "./EditCliente.vue?vue&type=style&index=0&id=749beb50&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749beb50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('749beb50')) {
      api.createRecord('749beb50', component.options)
    } else {
      api.reload('749beb50', component.options)
    }
    module.hot.accept("./EditCliente.vue?vue&type=template&id=749beb50&scoped=true", function () {
      api.rerender('749beb50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/users/EditCliente.vue"
export default component.exports